// extracted by mini-css-extract-plugin
export default {"root":"EOElGc","mobile":"g402c7"};